<template>
  <div class="content">
    <my-refresh-more :pageSize="10" v-model="goodsList" :getList="getList">
      <div slot="list" class="goods-list">
        <div
          v-for="(item, index) in goodsList"
          :key="index"
          class="goods-item"
          @click="navToDetailPage(item)"
        >
          <div class="image-wrapper">
            <van-image lazy-load class="image-wrapper-image" :src="item.picture"></van-image>
          </div>
          <span class="title clamp">{{item.name}}</span>
          <div class="price-box">
            <span class="price">{{item.price}}</span>
            <span>已售 {{item.salesVolume}}</span>
          </div>
          <div class="pro-box" v-if="item.joined&&item.activityType==1">
            <div class="progress-box">
              <progress
                :percent="item.activitySalesVolume/item.quantity*100"
                activeColor="#fa436a"
                active
                stroke-width="6"
              />
            </div>
            <span>{{item.activitySalesVolume}}/{{item.quantity}}</span>
          </div>
          <div class="pro-box" v-if="item.joined&&item.activityType==2">
            <span class="activText">下单可抽奖</span>
          </div>
        </div>
      </div>
    </my-refresh-more>
  </div>
</template>

<script>
export default {
  data () {
    return {
      priceOrder: 0, //1 价格从低到高 2价格从高到低
      goodsList: []
    };
  },

  created () {
  },
  methods: {
    getList (page, size) {
      let params = {
        page: page,
        size: size
      }
      return new Promise((resolve, reject) => {
        this.$http.request(this.$http.pathMap.collectList, 'get', params).then(res => {
          resolve(res.data)
        })
      })
    },
    //详情
    navToDetailPage (item) {
      let id = item.productId;
      this.$router.push({
        path: '/pages/product/product',
        query: {
          id
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
page,
.content {
  background: $page-color-base;
}
.pro-box {
  display: flex;
  align-items: center;
  margin-top: 5px;
  font-size: $uni-font-size-sm;
  color: $uni-font-size-base;
  padding-right: 5px;
}
.progress-box {
  flex: 1;
  border-radius: 10px;
  overflow: hidden;
  margin-right: 4px;
}
/* 分类 */
/* 商品列表 */
.goods-list {
  display: flex;
  flex-wrap: wrap;
  padding: 15px 15px 0 15px;
  background: #fff;
  .goods-item {
    display: flex;
    flex-direction: column;
    width: 48%;
    padding-bottom: 20px;
    &:nth-child(2n + 1) {
      margin-right: 4%;
    }
  }
  .image-wrapper {
    width: 100%;
    height: 182px;
    border-radius: 3px;
    overflow: hidden;
    .image-wrapper-image {
      width: 100%;
      height: 100%;
      opacity: 1;
    }
  }
  .title {
    font-size: $uni-font-size-lg;
    color: $font-color-dark;
    line-height: 20px;
  }
  .price-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 5px;
    font-size: 12px;
    color: $font-color-light;
  }
  .price {
    font-size: $uni-font-size-lg;
    color: var(--theme-font-color);
    line-height: 1;
    &:before {
      content: "￥";
      font-size: 13px;
    }
  }
}
.activText {
  font-size: 10px !important;
  font-size: $uni-font-size-lg;
  color: var(--theme-font-color);
  line-height: 1;
}
.clamp {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
